export function Footer({ color = 'text-white' }) {
  // Set a default color if none is provided
  return (
    <footer className={`p-4 text-[12px] justify-center lg:flex w-full text-center font-bold ${color}`}>
      This Product Is Protected By A Robust Intellectual Property Portfolio Encompassing Pending Patents And Other
      Exclusive Rights.
    </footer>
  );
}
